import * as ct from 'countries-and-timezones';

export type TimezoneOption = {
  value: string;
  label: string;
};

const continents = ['Africa', 'America', 'Asia', 'Atlantic', 'Australia', 'Europe', 'Pacific'];

const defaultTimezoneForCountry = {
  AR: 'America/Argentina/Buenos_Aires',
  AT: 'Europe/Vienna',
  BE: 'Europe/Brussels',
  BR: 'America/Sao_Paulo',
  CH: 'Europe/Zurich',
  CZ: 'Europe/Prague',
  DE: 'Europe/Berlin',
  EG: 'Africa/Cairo',
  ES: 'Europe/Madrid',
  FR: 'Europe/Paris',
  GB: 'Europe/London',
  IE: 'Europe/Dublin',
  IT: 'Europe/Rome',
  MT: 'Europe/Malta',
  MX: 'America/Mexico_City',
  NL: 'Europe/Amsterdam',
  PT: 'Europe/Lisbon',
  SE: 'Europe/Stockholm',
  UG: 'Africa/Kampala',
  ZA: 'Africa/Johannesburg',
  US: 'America/New_York',
  UY: 'America/Montevideo',
};

export const getTimezoneOptions = (): TimezoneOption[] => {
  const all = ct.getAllTimezones({
    deprecated: true,
  });
  const timezones = Array.isArray(all) ? all : Object.values(all);
  // Filter out all timezones that does not start with a continent
  const filteredTimezones = timezones.filter((tz) =>
    continents.some((continent) => tz.name.startsWith(continent))
  );
  const options: TimezoneOption[] = filteredTimezones.map((tz) => ({
    value: tz.name,
    label: tz.name,
  }));
  return options.sort((a, b) => a.label.localeCompare(b.label));
};

export const getTimezoneForCountry = (countryCode?: string | null): string | undefined => {
  if (!countryCode) return undefined;
  if (defaultTimezoneForCountry[countryCode as keyof typeof defaultTimezoneForCountry])
    return defaultTimezoneForCountry[countryCode as keyof typeof defaultTimezoneForCountry];
  return undefined;
};
